import template from './fleet.html';
import controller from './fleet.controller';

let fleetComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default fleetComponent;
